import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild, HostListener } from '@angular/core';
import { Subject, Subscription, take, takeUntil } from "rxjs";
import { UserModel } from "../../../models/user/user.model";
import { DialogService } from "primeng/dynamicdialog";
import { MenuItem, MessageService } from "primeng/api";
import { AuthenticationService } from "../../../services/authentication/authentication.service";
import { TranslateService } from "@ngx-translate/core";
import { Router } from "@angular/router";
import { SignoutModel } from "../../../models/signout/signout.model";
import { NotificationModel } from "../../../../resy-modul/models/notifications/notification.model";
import * as moment from "moment/moment";
import { OverlayPanel } from "primeng/overlaypanel";
import { CompressImageService } from "../../../services/common/compress-image.service";
import { NotificationService } from "../../../services/notifications/reservation-notifications.service";
import {
  NotificationPaginationHelperModel
} from "../../../../resy-modul/models/notifications/notification-pagination-helper.model";
import {
  ReservationDetailsComponent
} from "../../../../resy-modul/components/reservations/reservation-details/reservation-details.component";
import { FireMessagingService } from "../../../services/fire-messaging/fire-messaging.service";
import { environment } from 'src/environments/environment';
import { ApplicationId } from 'src/app/share-modul/enums/applicationid.enum';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
  //#region Fields
  @ViewChild('img_toggle') imgToggle: ElementRef;
  public unsubscribe: Subject<void> = new Subject<void>();
  public defaultImagePath: string = './assets/images/logo/profile-picture-placeholder.png';
  public imagePath: string = this.defaultImagePath;
  public items:  MenuItem[] = [];

  public productList: Array<any> = new Array<any>();

  public firstNameLastName: string;
  public email: string;
  public user: UserModel | null;

  public reservationList: NotificationModel[] = [];
  public paginationHelperModel: NotificationPaginationHelperModel;

  public showBadge: boolean = true;
  public newNotifications: boolean = false;
  public subscription: Subscription;
  public badgeValue: string = '';
  public unReadNotifications: number;
  public spinner: boolean = false;


  @ViewChild('menu_products', { static: false }) menuProducts: OverlayPanel;
  @ViewChild('op', { static: false }) overlayPanel: OverlayPanel;
  @ViewChild('menu_user', { static: false }) menuUser: OverlayPanel;
  @ViewChild('icon', { static: false }) toggleBtn: ElementRef;

  public pictureIsWrongFormat: boolean = false;
  public filePicture: any;
  public pictureFormat: Array<string>;
  //#endregion

  //#region Constructor
  constructor(private openFile: ElementRef,
              public elementRef: ElementRef,
              public dialogService: DialogService,
              public messageService: MessageService,
              public authenticationService: AuthenticationService,
              public translate: TranslateService,
              public _router: Router,
              private changeDetectorRef: ChangeDetectorRef,
              public firebaseMessagingService: FireMessagingService,
              public notificationsService: NotificationService,
              public compressImage: CompressImageService) {
    this.pictureFormat = ['image/png', 'image/jpg', 'image/jpeg'];
    this.translate.stream('HEADER.APP_LANGUAGE').subscribe(() => {
      this.addFunctionToProfilePictureMenu();
    });
  }

  ngOnInit(): void {
    navigator.serviceWorker.addEventListener('message', (event: MessageEvent) => {
      this.newNotifications = true;
      this.unReadNotifications++;
      this.updateBadgeValue();
    });

    this.loadProfileInfo();
    this.authenticationService.loginUser.pipe(takeUntil(this.unsubscribe)).subscribe(user => {
      this.user = user;
    });

    this.initNotifPaginationHelperModel();
    this.getAllProducts();
  }
  //#endregion

  //#region Public Methods
  public initNotifPaginationHelperModel(): void {
    this.paginationHelperModel = new NotificationPaginationHelperModel();
    this.paginationHelperModel.LanguageId = this.languageIdFromLocalStorage();
    this.paginationHelperModel.PageNumber = 1;
  }

  @HostListener('document:click', ['$event'])
  public onClick(event: MouseEvent): void {
    const isClickInsideDialog = this.dialogService.dialogComponentRefMap.size > 0;
    if (!isClickInsideDialog && !this.isClickInsideOverlayPanel(event) && !this.isClickOnTheNotification(event)) {
      this.overlayPanel.hide();
    }
  }

  public logOut(): void {
    let model = new SignoutModel();
    const token = localStorage.getItem('resy_refresh_token');
    if (token) {
      model.token = token;
    }
    this.authenticationService.loginUser.next(null);
    this.authenticationService.logout(model)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          localStorage.removeItem('resy_access_token');
          localStorage.removeItem('resy_refresh_token');
          this.firebaseMessagingService.removeToken();
        },
        error: errorResponse => {
          localStorage.removeItem('resy_access_token');
          localStorage.removeItem('resy_refresh_token');
          this.firebaseMessagingService.removeToken();
        }
      });
    this._router.navigate(['login']);
  }


  public loadProfileInfo(changeOnlyNotifNumber: boolean = false): void {
    this.authenticationService.getUserProfile()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          if (!changeOnlyNotifNumber) {
            this.firstNameLastName = response.firstName + ' ' + response.lastName;
            this.email = response.email;
            this.imagePath = response.profilePictureUrl ? response.profilePictureUrl : this.imagePath;
          }
          this.unReadNotifications = response.notificationToSeen;
          this.updateBadgeValue();
        },
        error: errorResponse => {
        }
      });
  }

  public openAddImage(): void {
    var element = this.openFile.nativeElement.querySelector(".open-file");
    element.click();
  }

  public onFileSelected(event: any): void {
    this.pictureIsWrongFormat = false;
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      if (!this.pictureFormat.includes(event.target.files[0].type)) {
        this.pictureIsWrongFormat = true;
        return;
      }
      let image: File = event.target.files[0]
      reader.readAsDataURL(image);// read file as data url
      this.compressImage.compress(image)
        .pipe(take(1))
        .subscribe(compressedImage => {
          this.filePicture = compressedImage;
          this.changeProfilePicture();
        })
    }
  }

  public changeProfilePicture(): void {
    this.menuUser.hide();
    this.authenticationService.uploadProfilePicture(this.filePicture).pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.imagePath = response.url;
          this.changeDetectorRef.detectChanges();
        },
        error: errorResponse => {
          this.messageService.add({severity: 'error', summary: "System error", life: 2000});
          this.changeDetectorRef.detectChanges();
        }
      });
  }

  public onHideProfileInfo(): void {
    this.pictureIsWrongFormat = false;
    this.filePicture = null;
  }

  public loadReservations(): void {
    this.spinner = true;
    this.subscription = this.notificationsService.listNotifications(this.paginationHelperModel).subscribe((response: any) => {
      if (this.paginationHelperModel.PageNumber > 1) {
        this.reservationList = this.reservationList.concat(response.data)
      }
      else {
        this.reservationList = response.data;
      }
      this.updateTimeElapsed();
      this.spinner = false;
    }, error => {
      this.spinner = false;
    });
  }

  public loadMoreReservations(): void {
    this.paginationHelperModel.PageNumber = this.paginationHelperModel.PageNumber + 1;
    this.loadReservations();
  }

  public refreshReservations(): void {
    this.newNotifications = false;
    this.reservationList = [];
    this.paginationHelperModel.PageNumber = 1;
    this.loadReservations();
  }

  public updateBadgeValue(): void {
    let value = '';
    if (this.showBadge && this.unReadNotifications > 0) {
      const length = this.unReadNotifications;
      value = length > 99 ? '99+' : length.toString();
    }
    this.badgeValue = value;
  }

  public updateTimeElapsed(): void {
    this.reservationList.forEach(x => x.timeElapsed = this.transformDate(x.sentDatetime));
  }

  public transformDate(reservationDateAndTime: string): string {
    const duration = moment.duration(moment().diff(moment(reservationDateAndTime)));
    let unit = ['days', 'hours', 'minutes'].find(u => duration.as(u as moment.unitOfTime.Base) >= 1) || 'minutes';
    return  this.translate.instant('HEADER.' + unit.toUpperCase() + '_AGO', {
      value: Math.floor(duration.as(unit as moment.unitOfTime.Base))
    });
  }

  public toggleShowNotification($event: MouseEvent): void {
    this.overlayPanel.toggle($event);
    this.showBadge = !this.showBadge;
    this.updateBadgeValue();
  }

  public onHideNotifications(): void {
    this.showBadge = true;
    this.reservationList = [];
    this.loadProfileInfo(true);
  }

  public onShowNotifications(): void {
    this.newNotifications = false;
    this.showBadge = false;
    this.updateBadgeValue();
    this.paginationHelperModel.PageNumber = 1;
    this.loadReservations();
  }

  public viewAllNotifications(): void {
    this.notificationsService.viewAllNotifications().subscribe(_ => {
      this.refreshReservations();
      this.unReadNotifications = 0;
      this.updateBadgeValue();
    });
  }

  public languageIdFromLocalStorage(): number {
    const langIdFromStorage = localStorage.getItem('languageId');

    if (langIdFromStorage) {
      return parseInt(langIdFromStorage);
    } else {
      return 1;
    }
  }

  public ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  public viewNotification(id: string) {
    this.notificationsService.viewNotification(id).subscribe(_ => {
      let currentNotification = this.reservationList.find(x => x.id === id);
      if (currentNotification) {
        currentNotification.seenByuser = true;
        this.unReadNotifications--;
        this.updateBadgeValue();
      }
    });
  }

  public deleteProfilePicture(): void {
    if (this.imagePath === this.defaultImagePath) {
      return;
    }
    this.menuUser.hide();
    this.authenticationService.deleteProfilePicture().pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.imagePath = this.defaultImagePath;
          this.changeDetectorRef.detectChanges();
        },
        error: errorResponse => {
          this.messageService.add({severity: 'error', summary: "System error", life: 2000});
          this.changeDetectorRef.detectChanges();
        }
      });
  }

  public addFunctionToProfilePictureMenu(): void {
    this.items = [{
      label: this.translate.instant('HEADER.NEW_PROFILE_PICTURE'),
      command: () => {
        this.openAddImage();
      }
    }, {
      label: this.translate.instant('HEADER.REMOVE_PROFILE_PICTURE'),
      command: () => {
        this.deleteProfilePicture();
      }
    }];
  }

  openReservationDetailsPopup(res: NotificationModel): void {
    const ref = this.dialogService.open(ReservationDetailsComponent, {
      data: {
        id: res.referenceObjectId,
        showVenueName: true
      },
      header: this.translate.instant('RESERVATION.RESERVATION_DETAILS'),
      width: '385px'
    });
    ref.onClose.subscribe((item: any) => {
      if (item !== null && item !== undefined) {
        let summary: string;
        if (item.priorityChanged) {
          summary = this.translate.instant("RESERVATION.RESERVATION_ADDED_TO_PRIORITY_LIST");
        } else {
          summary = item ? this.translate.instant("RESERVATION.RESERVATION_APPROVED") :
            this.translate.instant("RESERVATION.RESERVATION_DECLINED");
          this.viewNotification(res.id);
        }
        this.messageService.add({severity: 'success', summary, life: 3000});
      }
    });
  }

  getAllProducts(): void {
    // todo: fetch products
    // test
    this.productList = [
      {
        id: ApplicationId.SocialiteEvents.toString(),
        name: "Socialite Events",
        pictureUrl: "./assets/images/temporary/socialite-logo.png",
        url: environment.URLAdvertiser
      },
      {
        id: ApplicationId.SocialitePOS.toString(),
        name: "Socialite POS",
        pictureUrl: "./assets/images/temporary/socialite-pos-logo.png",
        url: environment.URLPos
      },
      ];
  }

  goToProductUrl(url: string){
    const search = '/';
    const replaceWith = '%2F';
    let refreshToken = localStorage.getItem("resy_refresh_token");
    if(refreshToken){
       const result = (localStorage.getItem("resy_refresh_token") as string).split(search).join(replaceWith);
       window.location.href = url+"/login/"+result;
    }
  }

  goToDashboard() {
    const search = '/';
    const replaceWith = '%2F';
    let refreshToken = localStorage.getItem("resy_refresh_token");
    if(refreshToken){
       const result = (localStorage.getItem("resy_refresh_token") as string).split(search).join(replaceWith);
       window.location.href = environment.URLSocialiteManager+"/login/"+result;
    }
  }
  //#endregion

  //#region Private Methods
  private isClickInsideOverlayPanel(event: MouseEvent): boolean {
    return this.overlayPanel.container && this.overlayPanel.container.contains(event.target as Node);
  }

  private isClickOnTheNotification(event: MouseEvent): boolean {
    return this.toggleBtn && this.toggleBtn.nativeElement.contains(event.target as Node);
  }
  //#endregion
}
